import styled from 'styled-components';

import {
  spacing, containers, defaultBoxShadow
} from '@comicrelief/component-library';

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  // Will likely need a new CMS field in the future, but this'll do for now:
  background: ${({ theme }) => theme.color('grey_light')};
  padding: ${({ paddingTop, paddingBottom }) => `${paddingTop} 1rem ${paddingBottom}`};
  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: ${({ paddingTop, paddingBottom }) => `${paddingTop} 2rem ${paddingBottom}`};
  }
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding: ${({ paddingTop, paddingBottom }) => `${paddingTop} 4rem ${paddingBottom}`};
  }
`;

const Wrapper = styled.div`
  position: relative;
  max-width: calc(${containers.medium} - 3rem);
  padding: ${spacing('l')};
  padding-bottom: ${spacing('lg')};
  border-radius: 1rem;
  ${defaultBoxShadow()}
  background: ${({ theme }) => theme.color('white')};

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    margin: 0 auto;
  }
`;

const InnerWrapper = styled.div`
  width: 100%;
`;

const CTA = styled.div`
  position: absolute;
  right: ${spacing('m')};
  bottom: -1.25rem;
`;

export {
  Container, Wrapper, InnerWrapper, CTA
};
